import { BudgetTranslationStrings } from "./budget-atom";

// Base configuration for English variants
export const kEnglishBase: BudgetTranslationStrings = {
  // Error messages
  kErrorMessage: "Something unusual happened 🤔",

  // Disclaimers
  kBudgetChatDisclaimer:
    "AI responses may contain errors. Check articles on Lumi News for complete details.",
  kBudgetChatOldDataDisclaimer:
    "This response is based on last year's data. Stay tuned for Budget 2026.",

  // Page titles and headers
  kInterestedTopicsTitle: "What are you interested in?",
  kInterestedTopicsSubtitle: "You can select up to 5",

  // Buttons
  kNextButton: "Next",
  kInterestedTopicsButton: "Pick at least one topic",

  // Breadcrumbs
  kBudgetBreadcrumb: "💰 Budget 2026",
  kPickStyleBreadcrumb: "🗣 Pick a style",
  kInterestedTopicsBreadcrumb: "💡 Interested topics",
  kYourSummaryBreadcrumb: "Your summary",

  // Response page content
  kRelevantReadsTitle: "Relevant articles",
  kRelevantNewsStacksTitle: "Relevant News Stacks",
  kExploreMoreTitle: "Dive into other topics",
  kResponseOptionsTitle: "Didn't see what you wanted?",
  kResponseGoBack: "Go back to topics",
  kResponseGoLanding: "Return to Budget 2026",
  kResponsePickAnotherStyle: "Pick another style",
  kLoadingText: "Loading...",
};

const kTranslations: Record<string, BudgetTranslationStrings> = {
  bahasa_malaysia: {
    // Error messages
    kErrorMessage: "Maaf, kesilapan telah berlaku 🧐",

    // Disclaimers
    kBudgetChatDisclaimer:
      "Respons dijana AI mungkin mengandungi kesilapan. Semak artikel di Lumi News untuk info lengkap.",
    kBudgetChatOldDataDisclaimer:
      "Respons ini berdasarkan data tahun lepas. Nantikan Belanjawan 2026.",

    // Page titles and headers
    kInterestedTopicsTitle: "Apa yang anda nak tahu?",
    kInterestedTopicsSubtitle: "Anda boleh pilih sebanyak 5 topik",

    // Buttons
    kNextButton: "Seterusnya",
    kInterestedTopicsButton: "Pilih sekurang-kurangnya satu",

    // Breadcrumbs
    kBudgetBreadcrumb: "💰 Belanjawan 2026",
    kPickStyleBreadcrumb: "🗣 Pilih gaya",
    kInterestedTopicsBreadcrumb: "💡 Topik yang diminati",
    kYourSummaryBreadcrumb: "Ringkasan anda",

    // Response page content
    kRelevantReadsTitle: "Artikel berkaitan",
    kRelevantNewsStacksTitle: "News Stacks berkaitan",
    kExploreMoreTitle: "Terokai topik lain",
    kResponseOptionsTitle: "Tidak nampak apa yang anda mahu?",
    kResponseGoBack: "Kembali ke topik",
    kResponseGoLanding: "Kembali ke Budget 2026",
    kResponsePickAnotherStyle: "Pilih gaya lain",
    kLoadingText: "Loading...",
  },

  chinese: {
    // Error messages
    kErrorMessage: "发生了不寻常的事 🤔",

    // Disclaimers
    kBudgetChatDisclaimer:
      "AI 回答可能包含错误。 完整详情请到 Lumi News 查看相关文章。",
    kBudgetChatOldDataDisclaimer:
      "本内容根据去年的数据整理。敬请关注《2026年财政预算案》。",

    // Page titles and headers
    kInterestedTopicsTitle: "你对什么感兴趣？",
    kInterestedTopicsSubtitle: "你可以选5样",

    // Buttons
    kNextButton: "下一页",
    kInterestedTopicsButton: "至少选择1个主题",

    // Breadcrumbs
    kBudgetBreadcrumb: "💰 2026年预算案",
    kPickStyleBreadcrumb: "🗣 选择风格",
    kInterestedTopicsBreadcrumb: "💡 感兴趣的话题",
    kYourSummaryBreadcrumb: "你的总结",

    // Response page content
    kRelevantReadsTitle: "相关报道",
    kRelevantNewsStacksTitle: "更多新闻汇编",
    kExploreMoreTitle: "探索其它话题",
    kResponseOptionsTitle: "没有看到您想要的内容？",
    kResponseGoBack: "返回话题",
    kResponseGoLanding: "返回2026年财案",
    kResponsePickAnotherStyle: "选择其他风格",
    kLoadingText: "正在加载。。。",
  },
};

const kStyleOverrides: Partial<
  Record<string, Pick<BudgetTranslationStrings, "kInterestedTopicsTitle">>
> = {
  manglish: {
    kInterestedTopicsTitle: "You interested in what ah?",
  },

  genz: {
    kInterestedTopicsTitle: "What are you vibin' with?",
  },
};

export const kBudgetConfig = (style) => {
  switch (style) {
    case "manglish":
      return {
        ...kEnglishBase,
        ...kStyleOverrides.manglish,
      };

    case "genz":
      return {
        ...kEnglishBase,
        ...kStyleOverrides.genz,
      };

    case "bahasa_malaysia":
    case "ms":
      return kTranslations.bahasa_malaysia;

    case "chinese":
    case "zh":
      return kTranslations.chinese;

    case "casual":
    case "en":
    default:
      return kEnglishBase;
  }
};

export const kBudgetStyles = {
  manglish: { emoji: "😎", label: "Manglish" },
  genz: { emoji: "💅", label: "Gen Z" },
  casual: { emoji: "⭐", label: "Casual" },
  bahasa_malaysia: { emoji: "🇲🇾", label: "Bahasa Malaysia" },
  chinese: { emoji: "🏮", label: "Chinese" },
};

export const kBudgetPages = (style) => {
  const copies = kBudgetConfig(style);

  return [
    copies.kBudgetBreadcrumb,
    copies.kPickStyleBreadcrumb,
    copies.kInterestedTopicsBreadcrumb,
    copies.kYourSummaryBreadcrumb,
  ];
};
